import React, { Component } from 'react';

import API from '../../../utils/API';
import FieldModal from '../../../components/modals/fieldModal';

class RemoveFilesModal extends Component {
	state = {
		submitting: false
	};

	removeFiles = async () => {
		const { orgId, assets, folders } = this.props;
		this.setState({ submitting: true })
		await API().post(`Organizations/${orgId}/removeAssets`, { assets: assets, folders: folders }).then((res) => {

			if (res.data) {
				let files = res.data.files
				let folders = res.data.folders;

				this.props.removeAndUpdateAssets(files, folders, () => {
					this.setState({ submitting: false });
					this.props.toggle();

				});


			}
		});
	};


	render() {
		const { isOpen, files, toggle, folders, assets } = this.props;
		const { submitting } = this.state;



		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={`Delete ${files.length > 1 ? 'Files' : 'File'}`}
					bodyHeaderText={
						<span>You are about to delete{' '}
							<b>
								{files.length} {files.length > 1 ? 'files' : 'file'}
							</b>, this is irreversible, would you like to continue?</span>
					}
					bodyContent={() => {
						return ('')
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
					actionButton={this.removeFiles}
					actionButtonDisabled={submitting}
					isDelete={true}
				></FieldModal>
			</div>

		);
	}
}

export default RemoveFilesModal;
